angular
    .module('clickbooth-common')
    .service('successModal', ['$rootScope', '$modal', function($rootScope, $modal) {
        var scope = $rootScope.$new(true);
        var modal = $modal({
            scope: scope,
            templateUrl: template('modals/success-modal'),
            backdrop: 'static',
            show: false
        });
        return {
            show: function(options, proceed) {
                scope.proceed = proceed;
                scope.modalOptions = options;
                modal.$promise.then(modal.show);
            }
        };

    }]);